module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as1802-490791ff37ec5b011f5f4fdb906a690e.jpg";